'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaults = require('../defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var request = function request(ctx) {
  var params = ctx.req.params;
  // 设置默认的 csrf 参数
  params.csrfToken = Object.assign({}, _defaults2.default.csrfToken || {}, params.csrfToken || {});
  // 设置 csrf 头部
  Object.assign(params.headers, (0, _utils.getCsrfHeader)(params));

  return ctx;
};

exports.default = { request: request };